module.exports = __webpack_public_path__ + "media/images/visa-978dc594.png";